import type { LanguageDefinition } from '../../types/i18n';

// Filter languages defined from .env
export const filterEnabledLanguages = (definedLanguages: LanguageDefinition[], enabledLanguages: string[]) => {
  return enabledLanguages.reduce((languages, languageCode) => {
    const foundLanguage = definedLanguages.find(({ code }) => code === languageCode);

    if (foundLanguage) {
      return [...languages, foundLanguage];
    }

    throw new Error(`Missing defined language for code: ${languageCode}`);
  }, [] as LanguageDefinition[]);
};

// Within i18n we currently only support language codes and not locale codes
export const getI18nSupportedLanguages = (languages: LanguageDefinition[]) => {
  return Array.from(
    languages.reduce<Set<string>>((set, { code }) => {
      set.add(code.split('-')[0]);
      return set;
    }, new Set<string>()),
  );
};
